// extracted by mini-css-extract-plugin
export default {"row_container":"Testamonies_row_container__MYC+J","column_container":"Testamonies_column_container__hfUw6","column_trust_container":"Testamonies_column_trust_container__bZvw7"};